import Vue from 'vue'
import Router from 'vue-router'

import Startseite from '@/views/Startseite'
import News from '@/views/News'
import Wir from '@/views/Wir'
import Idee from '@/views/Idee'
import Konzept from '@/views/Konzept'
import Vorteile from '@/views/Vorteile'
import Experten from '@/views/Experten'
import FAQ from '@/views/FAQ'
import Wettbewerb from '@/views/Wettbewerb'
import Kontakt from '@/views/Kontakt'
import Impressum from '@/views/Impressum'
import Datenschutz from '@/views/Datenschutz'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/',
      name: 'Startseite',
      component: Startseite
    },
    {
      path: '/News',
      name: 'News',
      component: News
    },
    {
      path: '/Team',
      name: 'Wir',
      component: Wir
    },
    {
      path: '/Idee',
      name: 'Idee',
      component: Idee
    },
    {
      path: '/Konzept',
      name: 'Konzept',
      component: Konzept
    },
    {
      path: '/Vorteile',
      name: 'Vorteile',
      component: Vorteile
    },
    {
      path: '/Experten',
      name: 'Experten',
      component: Experten
    },
    {
      path: '/FAQ',
      name: 'FAQ',
      component: FAQ
    },
    {
      path: '/Wettbewerb',
      name: 'Wettbewerb',
      component: Wettbewerb
    },
    {
      path: '/Kontakt',
      name: 'Kontakt',
      component: Kontakt
    },
    {
      path: '/Impressum',
      name: 'Impressum',
      component: Impressum
    },
    {
      path: '/Datenschutz',
      name: 'Datenschutz',
      component: Datenschutz
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js